import React, { useState } from 'react';
import { Button } from './ui/button';
import { Rocket, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { integrationsApi } from '../services/api';

/**
 * Launches BriefDesk in a new tab using a short-lived signed JWT
 * minted by the HR Hub backend (`/api/integrations/briefdesk/launch`).
 */
export const BriefDeskLauncher = ({ compact = false }) => {
  const [loading, setLoading] = useState(false);

  const handleLaunch = async () => {
    setLoading(true);
    try {
      const { data } = await integrationsApi.launchBriefDesk();
      if (!data?.url) throw new Error('No launch URL returned');
      window.open(data.url, '_blank', 'noopener,noreferrer');
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        err?.message ||
        'Failed to launch BriefDesk';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      size={compact ? 'icon' : 'sm'}
      onClick={handleLaunch}
      disabled={loading}
      data-testid="briefdesk-launcher-btn"
      className="gap-2"
      title="Open BriefDesk"
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Rocket className="h-4 w-4" />
      )}
      {!compact && <span>BriefDesk</span>}
    </Button>
  );
};

export default BriefDeskLauncher;
